import { Typography, Link, Notification } from '@telus-uds/components-web'
import useTranslate from '../../../../hooks/useTranslate'

const IneligibleMHNotification = () => {
  const translate = useTranslate()

  const updateParamsForMHError = (event) => {
    event.preventDefault()
    const lob = event.target.getAttribute('data-lob')
    const url = new URL(window.location.href)
    const params = new URLSearchParams(url.search)
    params.append('lob', lob)
    window.location.replace(`${url.origin}${url.pathname}?${params.toString()}`)
  }
  return (
    <div>
      <Notification
        variant={{ validation: 'error' }}
        testID="cart-validation-error-mh-core-notification"
      >
        <Typography variant={{ size: 'medium' }} testID="cart-validation-error-mh-notification">
          {translate('appNotification.validationErrorMH.heading')}
          <Link
            href="#"
            onClick={updateParamsForMHError}
            testID="cart-validation-error-MH-remove-mob-cta"
            data-lob="hs"
            variant={{ style: 'inline', size: 'small' }}
          >
            {translate('appNotification.validationErrorMH.removeMob.cta')}
          </Link>
          <Typography variant={{ size: 'medium' }}>
            {translate('appNotification.validationErrorMH.conjunction')}
          </Typography>
          <Link
            href="#"
            onClick={updateParamsForMHError}
            testID="cart-validation-error-MH-remove-hs-cta"
            data-lob="mob"
            variant={{ style: 'inline', size: 'small' }}
          >
            {translate('appNotification.validationErrorMH.removeHS.cta')}
          </Link>
          <Typography variant={{ size: 'medium' }}>
            {translate('appNotification.validationErrorMH.message')}
          </Typography>
        </Typography>
      </Notification>
    </div>
  )
}

export default IneligibleMHNotification
